import type { TModule } from '@modules/core/types';

import { MAKER_CHECKER_ROUTE_PATHS } from './config';
import { MAKER_CHECKER_ROUTES } from './index';

const makerCheckerModule: TModule = {
  id: 'maker-checker',
  fallbackRoute: [MAKER_CHECKER_ROUTE_PATHS.makerCheckerRequests],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...MAKER_CHECKER_ROUTES],
};

export { MAKER_CHECKER_ROUTE_PATHS as MakerCheckerRoutePaths };

export default makerCheckerModule;
